var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _path50, _path51;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    id: "_10_Ecommerce",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#EDEDED;}\n\t.st2{fill:#D3F0FD;}\n\t.st3{fill:#FC8A8A;}\n\t.st4{fill:#F96364;}\n\t.st5{fill:#FCB0B0;}\n\t.st6{fill:#A8B1B3;}\n\t.st7{fill:#7C8B8E;}\n\t.st8{fill:#7BDE9E;}\n\t.st9{fill:#51D27F;}\n\t.st10{fill:#A7EABF;}\n\t.st11{fill:#333333;}\n\t.st12{fill:#D3D9D9;}\n\t.st13{fill:#A8B2B4;}\n\t.st14{fill:#FEDD8E;}\n\t.st15{fill:#FEE9B4;}\n\t.st16{fill:#FDD367;}\n")), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M486.4,83v352.6H25.6V83c0-16.2,13.1-29.3,29.3-29.3h402.3C473.3,53.8,486.4,66.9,486.4,83z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M486.5,83.1v352.6h-29.2V83.1c0-16.2-13.1-29.3-29.3-29.3h29.2C473.4,53.8,486.5,66.9,486.5,83.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.7,406.5V83c0-4.5,3.6-8.1,8.1-8.1h386.3c4.5,0,8.1,3.6,8.1,8.1v323.4H54.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M333.8,199.3v11.1c0,2.5-2,4.6-4.6,4.6h-33.3c-2.5,0-4.6-2-4.6-4.6c0,0,0,0,0,0v-11.1c0-2.5,2-4.6,4.6-4.6h33.4  C331.8,194.8,333.8,196.8,333.8,199.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M333.8,199.3v11.1c0,2.5-2,4.6-4.6,4.6h-9.2c2.5,0,4.6-2,4.6-4.6v-11.1c0-2.5-2-4.6-4.6-4.6h9.2  C331.8,194.8,333.8,196.8,333.8,199.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M305.1,215h-9.2c-2.5,0-4.6-2-4.6-4.5c0,0,0,0,0,0v-11.1c0-2.5,2-4.6,4.6-4.6c0,0,0,0,0,0h9.2  c-2.5,0-4.6,2-4.6,4.6c0,0,0,0,0,0v11.1C300.6,212.9,302.6,215,305.1,215C305.1,215,305.1,215,305.1,215z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M155.3,364.3c0,9.1-7.4,16.5-16.5,16.5s-16.5-7.4-16.5-16.5c0-9.1,7.4-16.5,16.5-16.5  C147.9,347.9,155.3,355.3,155.3,364.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M243,364.3c0,9.1-7.4,16.5-16.5,16.5s-16.5-7.4-16.5-16.5c0-9.1,7.4-16.5,16.5-16.5c0,0,0,0,0,0  C235.6,347.9,243,355.3,243,364.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M155.3,364.3c0,9.1-7.4,16.5-16.5,16.5c-7,0-13.2-4.4-15.5-11c8.6,3,18-1.5,21-10.1c1.3-3.5,1.2-7.4,0-11  C150.9,351.2,155.3,357.4,155.3,364.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M243,364.3c0,9.1-7.4,16.5-16.5,16.5c-7,0-13.2-4.4-15.5-11c8.6,3,18-1.5,21-10.1c1.3-3.6,1.3-7.4,0-11  C238.6,351.2,243,357.4,243,364.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M268.7,226.2l-30.8,99h-99.4c-4.1,0-7.8-2.7-9-6.7l-24.9-80c-1.5-5,1.3-10.3,6.3-11.9c0.9-0.3,1.8-0.4,2.8-0.4  L268.7,226.2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "268.7,226.2 237.9,325.2 220.7,325.2 251.6,226.2 "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M155.7,325.2h-17.1c-4.1,0-7.8-2.7-9-6.7l-24.9-80c-1.6-5,1.2-10.3,6.3-11.9c0.9-0.3,1.9-0.4,2.8-0.4h17.1  c-5.2,0-9.5,4.3-9.5,9.5c0,0.9,0.1,1.9,0.4,2.8l24.9,80C147.9,322.5,151.5,325.2,155.7,325.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M329.3,190.7h-33.4c-4.7,0-8.6,3.8-8.6,8.6v1.6h-4.3c-6.3,0-11.9,4.1-13.8,10.2l-3.5,11.2H113.6  c-7.4,0-13.5,6-13.5,13.5c0,1.4,0.2,2.7,0.6,4l24.9,80c1.7,5.6,7,9.5,12.9,9.5h93.9l-4.3,13.8c-0.2,0.5-0.7,0.9-1.2,0.9h-88.1  c-11.3,0-20.5,9.2-20.5,20.5s9.2,20.5,20.5,20.5c11.3,0,20.5-9.2,20.5-20.5c0,0,0,0,0,0c0-4.5-1.6-8.9-4.4-12.5h55.5  c-2.8,3.6-4.3,7.9-4.4,12.5c0,11.3,9.1,20.5,20.4,20.6c11.3,0,20.5-9.1,20.6-20.4c0-7.9-4.4-15-11.5-18.5c0.1-0.2,0.2-0.5,0.3-0.7  l41.1-131.9c0.8-2.7,3.3-4.6,6.2-4.6h4.3v1.6c0,4.7,3.8,8.6,8.6,8.6h33.3c4.7,0,8.6-3.8,8.6-8.6v-11.1  C337.8,194.6,334,190.8,329.3,190.7z M133.3,317.3l-24.9-80c-0.9-2.9,0.7-6,3.6-6.9c0.5-0.2,1.1-0.2,1.6-0.2h149.7l-28.3,91h-96.4  C136.1,321.2,134,319.6,133.3,317.3z M138.8,376.8c-6.9,0-12.5-5.6-12.5-12.5c0-6.9,5.6-12.5,12.5-12.5c6.9,0,12.5,5.6,12.5,12.5  c0,0,0,0,0,0C151.3,371.2,145.7,376.8,138.8,376.8z M226.5,376.8c-6.9,0-12.5-5.6-12.5-12.5s5.6-12.5,12.5-12.5  c6.9,0,12.5,5.6,12.5,12.5l0,0C239,371.2,233.4,376.8,226.5,376.8L226.5,376.8z M329.9,210.4c0,0.3-0.3,0.6-0.6,0.6h-33.3  c-0.3,0-0.6-0.2-0.6-0.6v-11.1c0-0.3,0.3-0.6,0.6-0.6h33.4c0.3,0,0.6,0.3,0.6,0.6L329.9,210.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M186.4,306.8c-2.2,0-4-1.8-4-4v-54.2c0-2.2,1.8-4,4-4s4,1.8,4,4v54.2C190.4,305,188.6,306.8,186.4,306.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M217.6,306.8c-0.2,0-0.4,0-0.7-0.1c-2.2-0.4-3.7-2.4-3.3-4.6c0,0,0,0,0,0l9-54.2c0.3-2.2,2.3-3.7,4.5-3.5  c2.2,0.3,3.7,2.3,3.5,4.5c0,0.1,0,0.2,0,0.3l-9,54.2C221.2,305.4,219.5,306.8,217.6,306.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M155.3,306.8c-2,0-3.6-1.4-3.9-3.4l-8.9-54.2c-0.3-2.2,1.3-4.2,3.5-4.5c2.1-0.3,4,1.1,4.4,3.2l8.9,54.2  c0.4,2.2-1.1,4.2-3.3,4.6c0,0,0,0,0,0C155.7,306.8,155.5,306.8,155.3,306.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M407.9,252.6H325c-2.2,0-4-1.8-4-4s1.8-4,4-4h82.9c2.2,0,4,1.8,4,4S410.1,252.6,407.9,252.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M407.9,285.7h-100c-2.2,0-4-1.8-4-4s1.8-4,4-4h100c2.2,0,4,1.8,4,4S410.1,285.7,407.9,285.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M407.9,318.8H290.8c-2.2,0-4-1.8-4-4s1.8-4,4-4h117.1c2.2,0,4,1.8,4,4S410.1,318.8,407.9,318.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M407.9,351.9H273.6c-2.2,0-4-1.8-4-4s1.8-4,4-4h134.2c2.2,0,4,1.8,4,4S410.1,351.9,407.9,351.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M509,435.7v19.6c0,16.5-13.4,29.9-29.9,29.9H32.9C16.4,485.1,3,471.7,3,455.2v-19.6H509z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.1,485.1H32.9C16.4,485.1,3,471.7,3,455.2v-19.6h29.3v19.6C32.3,471.7,45.6,485.1,62.1,485.1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M509,435.7v19.6c0,16.5-13.4,29.9-29.9,29.9h-29.3c16.5,0,29.9-13.4,29.9-29.9v-19.6H509z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M328.6,435.7v14.1c0,4.9-4,8.9-8.9,8.9H192.2c-4.9,0-8.9-4-8.9-8.9v-14.1H328.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.7,435.7v14.1c0,4.9-4,8.8-8.9,8.8h-23.7c4.9,0,8.8-4,8.8-8.8v-14.1H328.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M76.1,118h72v15.1c0,19.9-16.1,36-36,36s-36-16.1-36-36c0,0,0,0,0,0V118z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M435.9,118v15.1c0.1,19.9-15.9,36.1-35.8,36.2c-19.9,0.1-36.1-15.9-36.2-35.8c0-0.1,0-0.3,0-0.4V118H435.9z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M220,118h72v15.1c0,19.9-16.1,36-36,36c-19.9,0-36-16.1-36-36V118z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M4.1,118h72v15.1c0,19.9-16.1,36-36,36s-36-16.1-36-36c0,0,0,0,0,0L4.1,118z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M292,118h72v15.1c0,19.9-16.1,36-36,36c-19.9,0-36-16.1-36-36V118z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M148,118h72v15.1c0,19.9-16.1,36-36,36s-36-16.1-36-36c0,0,0,0,0,0V118z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M507.9,118v15.1c0,19.9-16.1,36-36,36c-19.9,0-36-16.1-36-36c0,0,0,0,0,0V118H507.9z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.9,26.9L76.1,118h-72l26.3-74.7c3.5-9.8,12.7-16.4,23.2-16.4H98.9z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "161.8,26.9 148,118 76.1,118 98.9,26.9 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "224.6,26.9 220,118 148,118 161.8,26.9 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "287.4,26.9 292,118 220,118 224.6,26.9 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "350.2,26.9 364,118 292,118 287.4,26.9 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "413.1,26.9 435.9,118 364,118 350.2,26.9 "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M481.7,43.3l26.3,74.7h-72l-22.9-91.1h45.4C468.9,26.9,478.2,33.5,481.7,43.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M120.8,168c-2.9,0.7-5.8,1-8.7,1c-19.9,0-36-16.1-36-36V118h17.4v15.1C93.5,149.6,104.7,164,120.8,168z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M408.7,168c-2.9,0.7-5.8,1-8.7,1c-19.9,0-36-16.1-36-36V118h17.4v15.1C381.4,149.6,392.6,164,408.7,168z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M264.7,168c-2.9,0.7-5.8,1-8.7,1c-19.9,0-36-16.1-36-36V118h17.4v15.1C237.4,149.6,248.7,164,264.7,168z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48.8,168c-2.9,0.7-5.8,1-8.7,1c-19.9,0-36-16.1-36-36V118h17.4v15.1C21.5,149.6,32.7,164,48.8,168z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M336.7,168c-2.9,0.7-5.8,1-8.7,1c-19.9,0-36-16.1-36-36V118h17.4v15.1C309.4,149.6,320.7,164,336.7,168z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M192.7,168c-2.9,0.7-5.8,1-8.7,1c-19.9,0-36-16.1-36-36V118h17.4v15.1C165.4,149.6,176.7,164,192.7,168z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M480.7,168c-2.9,0.7-5.8,1-8.7,1c-19.9,0-36-16.1-36-36V118h17.4v15.1C453.4,149.6,464.6,164,480.7,168z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M53.5,26.9l-32,91.1H4.1l26.3-74.7C33.8,33.5,43.1,26.9,53.5,26.9z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "116.3,26.9 93.5,118 93.5,118 76.1,118 76.1,118 98.9,26.9 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "179.1,26.9 165.4,118 148,118 161.8,26.9 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "242,26.9 237.4,118 220,118 224.6,26.9 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "309.4,118 292,118 287.4,26.9 304.8,26.9 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "381.4,118 364,118 350.3,26.9 367.6,26.9 "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "453.3,118 435.9,118 413.1,26.9 430.5,26.9 "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M148,118v15.1c0,19.9-16.1,36-36,36c-2.9,0-5.8-0.3-8.7-1c6.3-1.6,12.1-4.9,16.7-9.5  c6.8-6.7,10.6-15.9,10.6-25.4V118H148z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M435.9,118v15.1c0,19.9-16.1,36-36,36c-2.9,0-5.8-0.3-8.7-1c6.3-1.6,12.1-4.9,16.7-9.5  c6.8-6.7,10.6-15.9,10.6-25.4V118H435.9z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M292,118v15.1c0,19.9-16.1,36-36,36c-2.9,0-5.8-0.3-8.7-1c6.3-1.6,12.1-4.9,16.7-9.5  c6.8-6.7,10.6-15.9,10.6-25.4V118H292z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.1,118v15.1c0,19.9-16.1,36-36,36c-2.9,0-5.8-0.3-8.7-1c6.3-1.6,12.1-4.9,16.7-9.5  c6.8-6.7,10.6-15.9,10.6-25.4V118H76.1z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M364,118v15.1c0,19.9-16.1,36-36,36c-2.9,0-5.8-0.3-8.7-1c6.3-1.6,12.1-4.9,16.7-9.5  c6.8-6.7,10.6-15.9,10.6-25.4V118H364z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M220,118v15.1c0,19.9-16.1,36-36,36c-2.9,0-5.8-0.3-8.7-1c6.3-1.6,12.1-4.9,16.7-9.5  c6.8-6.7,10.6-15.9,10.6-25.4V118H220z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M507.9,118v15.1c0,19.9-16.1,36-36,36c-2.9,0-5.8-0.3-8.7-1c6.3-1.6,12.1-4.9,16.7-9.5  c6.8-6.7,10.6-15.9,10.6-25.4V118H507.9z"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "98.9,26.9 76.1,118 58.7,118 81.5,26.9 "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "161.8,26.9 148,118 148,118 130.6,118 130.6,118 144.4,26.9 "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "224.6,26.9 220,118 202.6,118 207.2,26.9 "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "292,118 274.6,118 270,26.9 287.4,26.9 "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "364,118 346.6,118 332.9,26.9 350.2,26.9 "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "435.9,118 418.5,118 395.7,26.9 413.1,26.9 "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M507.9,118h-17.4l-32-91.1l0,0c10.4,0,19.7,6.6,23.2,16.4L507.9,118z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M509,432.7h-19.6V167.9c3.7-1.9,7.1-4.3,10-7.2c7.4-7.3,11.5-17.2,11.4-27.6V118c0-0.2-0.1-0.9-0.2-1  l-26.2-74.7c-3.9-11-14.3-18.4-26-18.4h-405c-11.7,0-22.1,7.4-26,18.4L1.2,117c0,0.1-0.1,0.8-0.2,1v15.1c0,14.7,8.3,28.2,21.5,34.8  v264.8H3c-1.7,0-3,1.3-3,3v19.6c0,18.1,14.7,32.8,32.9,32.9h446.3c18.1,0,32.8-14.7,32.9-32.9v-19.6C512,434,510.7,432.7,509,432.7z   M504.9,133.1c0,18.2-14.8,33-33,33c-18.2,0-33-14.8-33-33V121h66L504.9,133.1z M28.6,432.6V170.3c7.6,2.3,15.6,2.3,23.2-0.1v236.2  c0,1.7,1.3,3,3,3h402.5c1.7,0,3-1.3,3-3V170.3c7.5,2.4,15.6,2.4,23.2,0.1v262.3L28.6,432.6z M325.6,438.7v11.1  c0,3.2-2.6,5.9-5.9,5.9H192.2c-3.2,0-5.9-2.6-5.9-5.9v-11.1L325.6,438.7z M112,172.1c15.7-0.1,29.9-9.5,36-24  c8.4,19.9,31.2,29.2,51.1,20.9c9.4-4,16.9-11.4,20.9-20.9c8.4,19.9,31.2,29.2,51.1,20.9c9.4-4,16.9-11.4,20.9-20.9  c8.4,19.9,31.2,29.2,51.1,20.9c9.4-4,16.9-11.4,20.9-20.9c8.4,19.9,31.2,29.2,51.1,20.9c9.4-4,16.9-11.4,20.9-20.9  c3.6,8.5,10.1,15.5,18.3,19.7v235.7H57.7V167.8c3.6-1.9,7-4.3,9.9-7.2c3.6-3.6,6.5-7.8,8.5-12.5C82.1,162.6,96.3,172.1,112,172.1  L112,172.1z M79.1,133.1V121h66v12.1c0,18.2-14.8,33-33,33C93.8,166.1,79.1,151.3,79.1,133.1L79.1,133.1z M151,133.1V121h66v12.1  c0,18.2-14.8,33-33,33C165.8,166.1,151.1,151.3,151,133.1L151,133.1z M295,133.1V121h66v12.1c0,18.2-14.8,33-33,33  C309.8,166.1,295,151.3,295,133.1L295,133.1z M367,133.1V121h66v12.1c0,18.2-14.8,33-33,33C381.7,166.1,367,151.3,367,133.1  L367,133.1z M458.5,29.9c9.1,0,17.3,5.8,20.3,14.4l24.9,70.7h-65.4l-21.4-85.1H458.5z M410.7,29.9l21.4,85.1h-65.6l-12.8-85.1H410.7  z M347.7,29.9l12.8,85.1h-65.6l-4.3-85.1H347.7z M227.4,29.9h57.1l4.3,85.1h-65.7L227.4,29.9z M223,121h66v12.1  c0,18.2-14.8,33-33,33c-18.2,0-33-14.8-33-33L223,121z M164.3,29.9h57.1l-4.3,85.1h-65.6L164.3,29.9z M101.3,29.9h57L145.4,115H79.9  L101.3,29.9z M33.2,44.3c3-8.6,11.2-14.4,20.3-14.4h41.6L73.7,115H8.3L33.2,44.3z M7.1,133.1V121h66v12.1c0,18.2-14.8,33-33,33  C21.9,166.1,7.1,151.3,7.1,133.1z M506,455.2c0,14.8-12,26.9-26.9,26.9H32.9C18,482.1,6,470.1,6,455.2v-16.6h174.4v11.1  c0,6.5,5.3,11.8,11.9,11.9h127.6c6.5,0,11.8-5.3,11.9-11.9v-11.1H506V455.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.c3f70a24b8c28819ccf60037e97bfa09.svg";
export { ForwardRef as ReactComponent };